export default "__VITE_PUBLIC_ASSET__73c8a3d1__"